/* Espaço de anúncio do meio da notícia: o tema renderiza o banner depois do texto
   (escondido) e este script o move para o meio, depois de metade dos parágrafos
   (a partir do 3º). Textos com menos de 5 parágrafos não recebem o banner do meio. */
(function () {
    var origem = document.querySelector('[data-pn-meio]');
    if (!origem) return;

    var espaco = origem.querySelector('.pn-espaco');
    var conteudo = document.querySelector('.article .gh-content');
    var paragrafos = conteudo
        ? Array.prototype.filter.call(conteudo.children, function (el) { return el.tagName === 'P'; })
        : [];

    if (!espaco || !espaco.querySelector('.pn-item, .pn-casa-wrap') || paragrafos.length < 5) {
        origem.parentNode.removeChild(origem);
        return;
    }

    // Bom ponto de corte: parágrafo seguido de outro parágrafo ou de um intertítulo (pausa
    // natural) e que não anuncia o que vem depois (terminado em ":"), para não separar uma
    // frase da tabela/lista/imagem dela
    function bomPonto(p) {
        var proximo = p.nextElementSibling;
        return proximo && /^(P|H2|H3)$/.test(proximo.tagName) && !/:\s*$/.test(p.textContent);
    }

    var preferido = Math.max(2, Math.floor(paragrafos.length / 2) - 1);
    var alvo = null;
    for (var d = 0; d < paragrafos.length && !alvo; d++) {
        // procura a partir do meio, alternando para frente e para trás
        [preferido + d, preferido - d].forEach(function (i) {
            if (!alvo && i >= 2 && i < paragrafos.length - 1 && bomPonto(paragrafos[i])) alvo = paragrafos[i];
        });
    }

    if (alvo) alvo.parentNode.insertBefore(espaco, alvo.nextSibling);
    origem.parentNode.removeChild(origem);
})();
